import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Tara, TaraUpdate } from './tari.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TariService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private storeTariUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.storeTara;
    private updateTariUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.updateTari;
    private deleteTaraUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.deleteTara;
    private getTariPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.getTariPublic;
    private getTariActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.getTariActive;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.changeStatusTariActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.tari.changeStatusTariPublic;

    constructor(private http: HttpClient) { }

    addTara(tara: Tara) {
        return this.http.post(this.storeTariUrl, tara, this.httpOptions);
    }

    updateTara(tara: TaraUpdate) {
        return this.http.put(this.updateTariUrl, tara, this.httpOptions);
    }

    deleteTara(id: number) {
        return this.http.delete(this.deleteTaraUrl + id);
    }

    getTariActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTariActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get tari:', error);
                    return throwError(error);
                })
            );
    }

    getTariPublic() {
        return this.http.get(this.getTariPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
